import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as actions from '../actions/category';
var initialState = {
  isProcessing: false,
  error: null,
  data: [],
  selectItem: null,
  bulkPrice: {
    data: 0,
    campaign_rate: 0,
    campaign: 0,
    home_data: 0,
    home_campaign: 0,
    home_campaign_rate: 0,
    all_data: 0,
    all_campaign: 0,
    all_campaign_rate: 0
  }
};
export default reducerWithInitialState(initialState).case(actions.requestCategories, function (state) {
  return Object.assign({}, state, {
    isProcessing: true,
    error: null
  });
}).case(actions.successCategories, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: null,
    data: payload
  });
}).case(actions.failureCategories, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: payload
  });
}).case(actions.requestCategoryDetail, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: true,
    error: null,
    selectItem: state.data.findById(payload) || null
  });
}).case(actions.successCategoryDetail, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: null,
    selectItem: payload
  });
}).case(actions.failureCategoryDetail, function (state, payload) {
  return Object.assign({}, state, {
    isProcessing: false,
    error: payload
  });
}).case(actions.requestBulkPrice, function (state) {
  return Object.assign({}, state);
}).case(actions.successBulkPrice, function (state, payload) {
  return Object.assign({}, state, {
    bulkPrice: payload
  });
}).case(actions.failureBulkPrice, function (state) {
  return Object.assign({}, state, {
    bulkPrice: {
      data: 0,
      campaign: 0,
      campaign_rate: 0,
      home_data: 0,
      home_campaign: 0,
      home_campaign_rate: 0,
      all_data: 0,
      all_campaign: 0,
      all_campaign_rate: 0
    }
  });
});